import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-task-details-dialog',
  template: `
    <div *ngFor="let task of data.tasks" 
         [class.completed]="task.complete"
         [class.approved]="task.type === 'approval' && task.completed"
         class="task-item"
         (click)="!task.complete && selectTask(task)">
      <div class="task-content">
        <span class="task-title">{{task.name}}</span>
        <span *ngIf="task.type === 'approval' && task.complete" class="approved-tag">
          <i class="fas fa-check"></i> Approved
        </span>
      </div>
    </div>
  `,
  styles: [`
    .task-list {
      min-width: 200px;
      padding: 4px 0;
      border-radius: 4px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
    .task-item {
      padding: 6px 10px;
      cursor: pointer;
      transition: background-color 0.2s;
      border-bottom: 1px solid #eee;
    }
    .task-item:last-child {
      border-bottom: none;
    }
    .task-item:not(.completed):hover {
      background-color: #f5f5f5;
    }
    .task-item.completed {
      background-color: #f8f8f8;
      cursor: default;
    }
    .task-item.approved {
      background-color: #e6f4ea;
    }
    .task-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .task-title {
      font-size: 12px;
      color: #333;
    }
    .approved-tag {
      font-size: 11px;
      color: #137333;
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .approved-tag i {
      font-size: 10px;
    }
  `]
})
export class TaskDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TaskDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {tasks: any[]}
  ) {}

  selectTask(task: any) {
    this.dialogRef.close({ type: task.type, formId: task.formId, formName: task.name, taskId: task.taskId });
  }
}
